var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeather(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.356 244.239L351.87 287.986H449.61C439.736 298.61 453.359 284.861 403.365 334.857L255.755 383.979H353.995C279.002 457.098 159.39 454.598 107.145 438.974L41.027 504.969C31.653 514.344 16.405 514.344 7.031 504.969C-2.344 495.595 -2.344 480.346 7.031 470.972L266.504 211.742C272.753 205.492 272.753 195.368 266.504 189.119C260.254 182.869 250.13 182.869 243.881 189.119L65.524 367.355C58.775 306.985 68.649 216.617 129.143 156.246C153.89 131.498 136.267 149.122 214.884 70.628C305.5 -19.99 404.614 -17.615 467.108 44.88C517.728 95.376 528.852 169.745 483.356 244.239Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/feather.3cc2be00cd5d2a4650d00f282b698fa4.svg";
export { ForwardRef as ReactComponent };